// Libs
import { createContext } from 'react';
import { IContextTreeItems } from '~/utils/interface/common';
// Components, Layouts, Pages
// Others
// Styles, images, icons

const GroupContext = createContext<IContextTreeItems<any>>({} as IContextTreeItems<any>);

export default GroupContext;
